import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ApiResult } from 'src/app/common/components/viewmodels/apiResult';
import { SystemParameters } from 'src/app/common/components/viewmodels/SystemParameters';
import { PrintConfigViewModel, TicketConfig } from 'src/app/common/components/viewmodels/TicketConfig';
import { baseService } from '../base/base.service';
import { PrintableTickets } from 'src/app/common/components/viewmodels/PrintableTickets';

@Injectable({
  providedIn: 'root',
})
export class TicketConfigService extends baseService {
  constructor(
    public http: HttpClient,
    @Inject('BASE_URL') public baseUrl: string,
    toastr: ToastrService,
    router: Router
  ) {
    super(toastr, router);
  }

  public getTicketConfigs(): Observable<ApiResult<TicketConfig[]>> {
    return this.http.get<ApiResult<TicketConfig[]>>(`${this.baseUrl}TicketConfigs/GetTicketConfigs`).pipe(
      map((x) => {
        var result = this.checkResult<TicketConfig[]>(x);
        return result;
      }),
      catchError((error) => this.handleError<TicketConfig[]>(error))
    );
  }

  public getPrintConfig(): Observable<ApiResult<PrintConfigViewModel>> {
    return this.http.get<ApiResult<PrintConfigViewModel>>(`${this.baseUrl}TicketConfigs/GetPrintConfig`).pipe(
      map((x) => {
        var result = this.checkResult<PrintConfigViewModel>(x);
        return result;
      }),
      catchError((error) => this.handleError<PrintConfigViewModel>(error))
    );
  }

  public getParameters(): Observable<ApiResult<SystemParameters>> {
    return this.http.get<ApiResult<SystemParameters>>(`${this.baseUrl}TicketConfigs/GetParameters`).pipe(
      map((x) => {
        var result = this.checkResult<SystemParameters>(x);
        return result;
      }),
      catchError((error) => this.handleError<SystemParameters>(error))
    );
  }

  public GenerateTestTicket(): Observable<ApiResult<PrintableTickets>> {
    return this.http.post<ApiResult<PrintableTickets>>(`${this.baseUrl}Tickets/GenerateTestTicket`, null).pipe(
      map((x) => this.checkResult<PrintableTickets>(x)),
      catchError((error) => this.handleError<PrintableTickets>(error))
    );
  }

  public edit(ticketConfig: TicketConfig): Observable<ApiResult<string>> {
    return this.http.post<ApiResult<string>>(`${this.baseUrl}TicketConfigs/EditTicketConfig`, ticketConfig).pipe(
      map((x) => this.checkResult<string>(x)),
      catchError((error) => this.handleError<string>(error))
    );
  }

  public editPrintConfig(printConfig: PrintConfigViewModel): Observable<ApiResult<string>> {
    return this.http.post<ApiResult<string>>(`${this.baseUrl}TicketConfigs/EditPrintConfig`, printConfig).pipe(
      map((x) => this.checkResult<string>(x)),
      catchError((error) => this.handleError<string>(error))
    );
  }
}
